import React, { useState } from 'react';

import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import myFunctions from '../myFunctions';

const PopUpRegular = (props) => {


    const [open, setOpen] = useState(true);
    const [inputTxt, setInputTxt] = useState("");
    const [err, setErr] = useState((props.errorMsg == "") ? false : true);

    const saveMe = () => {

        if (inputTxt != "") {
            props.okClick(inputTxt);
        }
        else {
            setErr(true);
        }
    };


    const handleClose = () => {
        props.cancelClick();
    };

    myFunctions.useEscapeKey(handleClose);

    const [timer, setTimer] = useState(60);
    const [canResend, setCanResend] = useState(false);

    React.useEffect(() => {
        if (timer > 0) {
            const interval = setInterval(() => {
                setTimer(prev => prev - 1);
            }, 1000);
            return () => clearInterval(interval);
        } else {
            setCanResend(true);
        }
    }, [timer]);

    const handleResend = () => {
        if (canResend) {
            props.recreateCode();
            setTimer(60);
            setCanResend(false);
        }
    };

    return (
        <Dialog open={open} onClose={handleClose} disableEscapeKeyDown className={`textSizeDiag popDiagBlock ${props.cssStyl ? props.cssStyl : ""}`}>
            <DialogTitle className={"theTitlePop"}>
                {props.Title.map((txtItm, index) => {
                    return (
                        <span key={index} >{txtItm}</span>
                    )
                })}
            </DialogTitle>
            <DialogContent>
                <DialogContentText className={"theTxtPop"}>
                    {props.ContentText.map((txtItm, index) => {
                        return (
                            <span key={index} >{txtItm}<br /></span>
                        )
                    })}
                </DialogContentText>
                <TextField
                    autoFocus
                    margin="dense"
                    id="name"
                    label={props.inLabel}
                    type="text"
                    fullWidth
                    variant="standard"
                    className="centerText"
                    onChange={(e) => { setInputTxt(e.target.value); setErr(false) }}
                />

                <button type="button" onClick={handleResend} className={`btnReset spacePadBig centerText centerMargin ${canResend ? 'pointing' : ''}`}
                   style={{ display: 'block', cursor: canResend ? 'pointer' : 'not-allowed', opacity: canResend ? 1 : 0.5 }}>
                    {canResend ? 'שלח לי שוב' : `לנסיון שליחה חוזרת יש להמתין ${timer} שניות`}
                </button>
                {err ? <div role="alert" style={{ color: 'red', fontWeight: 'bold' }}>{props.errorMsg}</div> : ""}

            </DialogContent>
            <DialogActions >
                <button type="button" className="centerMe btn btn-success btnPopRegular pointing" onClick={() => saveMe()}>אימות</button>
            </DialogActions>
        </Dialog>

    );
}

export default PopUpRegular;